// import { defineMessage } from "@lingui/macro";
import "./Footer.css";
import twitterIcon from "img/ic_twitter.svg";
import discordIcon from "img/ic_discord.svg";
//import telegramIcon from "img/ic_telegram.svg";
import githubIcon from "img/ic_github.svg";
import mediumIcon from "img/ic_medium.svg";
import { MessageDescriptor } from "@lingui/core";
import pythIcon from "img/pythIcon.svg";

type Link = {
  text: MessageDescriptor;
  link: string;
  external?: boolean;
  isAppLink?: boolean;
};

type SocialLink = {
  link: string;
  name: string;
  icon: string;
};

export const FOOTER_LINKS: { home: Link[]; app: Link[] } = {
  home: [
    // { text: defineMessage({ message: "Terms and Conditions" }), link: "/terms-and-conditions" },
    // { text: defineMessage({ message: "Referral Terms" }), link: "/referral-terms" },
    // { text: defineMessage({ message: "Media Kit" }), link: "https://cadio.gitbook.io/cad/media-kit", external: true },
  ],
  app: [
    // { text: defineMessage({ message: "Media Kit" }), link: "https://cadio.gitbook.io/cad/media-kit", external: true },
  ],
};

export function getFooterLinks(isHome) {
  return FOOTER_LINKS[isHome ? "home" : "app"];
}

export const SOCIAL_LINKS: SocialLink[] = [
  // { link: "https://cadenceprotocol.gitbook.io/cadence-protocol/trading-on-cadence-protocol/pyth-price-feeds", name: "Pyth", icon: pythIcon },
  { link: "https://twitter.com/CadenceProtocol", name: "Twitter", icon: twitterIcon },
  { link: "https://medium.com/@CadenceProtocol", name: "Medium", icon: mediumIcon },
  { link: "https://t.co/6tNW7SdieH", name: "Discord", icon: discordIcon },
  { link: "https://cadenceprotocol.gitbook.io/cadence-protocol/introduction-to-cadence/welcome-to-cadence", name: "Docs", icon: githubIcon },
];
